import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import toastr from 'toastr';
import clsx from 'clsx'
import { projectAPI } from '../../../api';

import {Modal} from '../../../components/Modal'
import {APIAccessRequestForm} from '../../../components/APIAccessRequestForm'


import {APP_NAME} from '../../../utils'

interface Props {
  show: boolean
  handleClose: () => void
  handleAdded: () => void
}

const schema = Yup.object().shape({
  name: Yup.string().required('Required'),
  origin: Yup.string().required('Required'),
  for_load_testing: Yup.boolean().required('Required'),
  full_name: Yup.string().when('for_load_testing', (for_load_testing, schema) => {
    if (!for_load_testing[0]) {
      return schema.required('Required')
    }
    return schema
  }),
  email: Yup.string().when('for_load_testing', (for_load_testing, schema) => {
    if (!for_load_testing[0]) {
      return schema.email('Wrong email format')
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Required')
    }
    return schema
  }),
  organization: Yup.string().when('for_load_testing', (for_load_testing, schema) => {
    if (!for_load_testing[0]) {
      return schema.required('Required')
    }
    return schema
  }),
  use_case: Yup.string().when('for_load_testing', (for_load_testing, schema) => {
    if (!for_load_testing[0]) {
      return schema.required('Required')
    }
    return schema
  }),
  terms_agreed: Yup.boolean().when('for_load_testing', (for_load_testing, schema) => {
    if (!for_load_testing[0]) {
      return schema.required('Required').oneOf([true], 'You must agree to continue')
    }
    return schema
  })
});

const APIAccessAddModal : React.FC<Props> = ({show, handleClose, handleAdded}) => {

  const [handling, setHandling] = useState(false)

  const formik = useFormik({
    initialValues: {'name': '', 'description': '', 'origin':APP_NAME, 'for_load_testing': false, 'full_name': '', 'email': '', 'organization': '', 'use_case': '', 'terms_agreed': false},
    validationSchema: schema,
    onSubmit: async (values) => {
      setHandling(true)
      try{
        values['for_load_testing'] = formik.values.for_load_testing
        if( !values['for_load_testing'] ){
          values['requester'] = {
            'full_name': formik.values.full_name,
            'email': formik.values.email,
            'organization': formik.values.organization,
            'use_case': formik.values.use_case,
            'terms_agreed': formik.values.terms_agreed
          }
        }
        await projectAPI.add(values)
        formik.resetForm()
        handleAdded()
        handleClose()
      } finally {
        setHandling(false)
      }
    }
  })

  return <Modal show={show} handleClose={handleClose} dialogClassName="" title={'Add API Access'}>
    <form
      className='form fv-plugins-bootstrap5 fv-plugins-framework'
      onSubmit={formik.handleSubmit}
      noValidate
    >
      <div className='fv-row mb-5'>
        <div className="form-check form-switch form-check-custom form-check-solid">
          <input 
            className="form-check-input" 
            type="checkbox" 
            checked={formik.values.for_load_testing}
            onChange={(e) =>
              formik.setFieldValue("for_load_testing", e.target.checked)
            }
            onBlur={formik.handleBlur}
            id="for-load-testing"
          />
          <label className="form-check-label" htmlFor="for-load-testing">
            For load testing
          </label>
        </div>
      </div>
      <div className='fv-row mb-5 form-floating'>
        <input 
          placeholder="name"
          {...formik.getFieldProps('name')}
          className={clsx(
            'form-control bg-transparent h-60px border border-gray-400',
            {'is-invalid': formik.touched.name && formik.errors.name},
            {
              'is-valid': formik.touched.name && !formik.errors.name,
            }
          )}
          type='text'
          name='name'
        />
        <label className='form-label fs-6 text-gray-600'>Name</label>
      </div>
      <div className='fv-row mb-5 form-floating'>
        <input 
          placeholder="description"
          {...formik.getFieldProps('description')}
          className={clsx(
            'form-control bg-transparent h-60px border border-gray-400',
            {'is-invalid': formik.touched.description && formik.errors.description},
            {
              'is-valid': formik.touched.description && !formik.errors.description,
            }
          )}
          type='text'
          name='description'
        />
        <label className='form-label fs-6 text-gray-600'>description</label>
      </div>
      { !formik.values.for_load_testing && (
        <>
          <div className="separator my-5"></div>
          <h2 className="mb-5">Request Details</h2>
          <APIAccessRequestForm formik={formik}/>
        </>
      )}
      <div className="text-center">
        <button
          type='submit'
          className="btn btn-primary"
          disabled={handling || !formik.isValid}
        >
          {!handling && <span className='indicator-label'>Add</span>}
          {handling && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        
        <button type="button" className="btn btn-light ms-3" onClick={handleClose}>
          Close
        </button>
      </div>
    </form>
  </Modal>
}

export {APIAccessAddModal}